import { createStyles } from 'antd-style'

import { createSupplyDemandApi } from '@eastcoal/api/trade/supplyDemandOperation/createSupplyDemand'

import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { BasicProps } from '@eastcoal/common/types/component'
import { pick } from '@eastcoal/common/utils/object'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { SchemaForm } from '@eastcoal/formily/components/SchemaForm'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { SmsInput } from '@eastcoal/formily/components/SmsInput'
import { TextArea } from '@eastcoal/formily/components/TextArea'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { SmsTemplateCode } from '@eastcoal/shared/enums/SmsTemplateCode'
import { SupplyDemandType } from '@eastcoal/shared/enums/SupplyDemandType'

import { FloorBlock } from '../../../components/FloorBlock'
import { FloorCard } from '../../../components/FloorCard'

import { SupplyDemandTelehoneInput } from './TelephoneInput'

const schema: SchemaItem[] = [
  {
    name: 'content',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': TextArea,
    'x-component-props': {
      placeholder:
        '请提交您的真是需求，包括品种、指标等信息，收到后我们将及时回电确认，并竭力为您促成交易哦！'
    },
    'x-validator': [
      {
        required: true,
        message: '请输入您的需求'
      }
    ]
  },
  {
    name: '{ type, telephone }',
    type: 'object',
    default: {
      type: SupplyDemandType.DEMAND,
      telephone: ''
    },
    'x-decorator': FormItem,
    'x-component': SupplyDemandTelehoneInput,
    'x-validator': [
      {
        validator({ telephone }) {
          if (!telephone) {
            return '请填写手机号码'
          }
        }
      }
    ]
  },
  {
    type: 'object',
    name: 'smsCode',
    'x-decorator': FormItem,
    'x-component': SmsInput,
    'x-component-props': {
      captchaEnabled: true,
      templateCode: SmsTemplateCode.SUPPLY_DEMAND,
      phone: '{{ $values.telephone }}'
    },
    'x-validator': {
      required: true,
      message: '请输入验证码'
    }
  }
]

const useStyles = createStyles(({ token }) => ({
  form: {
    paddingBlockStart: token.paddingSM,
    paddingBlockEnd: token.padding
  }
}))

export const SupplyDemandFormFloor = (props: BasicProps) => {
  const { message } = useFeedback()
  const {
    user: { phone }
  } = useAuthStore(state => pick(state, ['user']))
  const form = useCreationForm({
    values: {
      telephone: phone,
      smsCode: { ticketId: undefined, code: undefined }
    }
  })

  const handleSubmit = () => {
    form.submit(async values => {
      await createSupplyDemandApi({
        ...values,
        ticketId: values.smsCode.ticketId,
        code: values.smsCode.code
      })
      message.success('提交成功！')
      form.reset('*(content,smsCode)')
    })
  }

  const { styles } = useStyles()

  return (
    <FloorBlock>
      <FloorCard {...props} bordered={false} title='委托找货'>
        <SchemaForm
          className={styles.form}
          form={form}
          grid={{ columns: 1 }}
          name='supplyDemandCreateForm'
          schema={schema}
        >
          <ThrottleButton
            htmlType='submit'
            type='primary'
            onClick={handleSubmit}
          >
            确认提交
          </ThrottleButton>
        </SchemaForm>
      </FloorCard>
    </FloorBlock>
  )
}
